<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 중점사항 -->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :isNote="true"
      tableHeaderNote="비고(조치결과)"
      title="중점사항"
      :list="pointInspectTable"
      @update-list-check="pointUpdateListCheck"
    />

    <!-- 일반사항 -->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :isNote="true"
      tableHeaderNote="비고(조치결과)"
      title="일반사항"
      :list="defaultInspectTable"
      @update-list-check="defaultUpdateListCheck"
    />

    <!-- 점검자 의견 -->
    <div class="print-container flex items-start mt-8">
      <div class="label-text mr-4 mt-2">점검자 의견</div>
      <p v-if="isPrint" class="print-textarea">{{ form.inputA_1 }}</p>
      <ml-textarea
        v-else
        class="flex-1 w-full"
        rows="5"
        v-model="form.inputA_1"
        :readonly="board.readonly"
      />
    </div>

    <!-- 사진대지 -->
    <PhotoUploadGridModule
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!--    파일첨부-->
    <FileUploadModule
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :isPrint="isPrint"
      :readonly="board.readonly"
    />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";

export default {
  components: {
    FileUploadModule,
    PhotoUploadGridModule,
    FieldSelectModule,
    TableInspect,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (
          !this.form ||
          !this.form.pointInspectList ||
          this.form.pointInspectList.length === 0
        ) {
          this.form.pointInspectList = this.pointInspectTable;
        }
        if (
          !this.form ||
          !this.form.defaultInspectList ||
          this.form.defaultInspectList.length === 0
        ) {
          this.form.defaultInspectList = this.defaultInspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    pointInspectTable() {
      return [
        {
          id: 1,
          title: "위험작업",
          label: "산업재해 예방계획의 수립",
          is_checked: "",
        },
        {
          id: 2,
          title: "위험작업",
          label: "안전장치 작동/점검 상태",
          is_checked: "",
        },
        {
          id: 3,
          title: "위험작업",
          label: "유도원 또는 하부통제인원 배치상태",
          is_checked: "",
        },
        {
          id: 4,
          title: "화기작업",
          label: "화기감시자, 소화기구 배치 여부",
          is_checked: "",
        },
        {
          id: 5,
          title: "화기작업",
          label: "불티비산방지조치 여부",
          is_checked: "",
        },
        {
          id: 6,
          title: "화기작업",
          label: "인화성/가연성 물질 제거 여부",
          is_checked: "",
        },
      ];
    },
    defaultInspectTable() {
      return [
        {
          id: 1,
          title: "정리정돈",
          label: "작업공간 구획 여부",
          is_checked: "",
        },
        {
          id: 2,
          title: "정리정돈",
          label: "작업공간 주변 정리정돈 상태",
          is_checked: "",
        },
        {
          id: 3,
          title: "정리정돈",
          label: "이동 동선 확보 상태",
          is_checked: "",
        },
        {
          id: 4,
          title: "보호구",
          label: "근로자 적정 보호구 착용상태",
          is_checked: "",
        },
        {
          id: 5,
          title: "눈관리 상태",
          label: "각 종 위험표지 상태 등",
          is_checked: "",
        },
        {
          id: 6,
          title: "공도구 관련",
          label: "공도구 점검 여부",
          is_checked: "",
        },
        {
          id: 7,
          title: "공도구 관련",
          label: "미사용 공도구 전원제거 여부",
          is_checked: "",
        },
        {
          id: 8,
          title: "공도구 관련",
          label: "공도구 방호장치 설치 여부",
          is_checked: "",
        },
        {
          id: 9,
          title: "시설 관련",
          label: "작업도구 목적 외 사용 여부",
          is_checked: "",
        },
        {
          id: 10,
          title: "시설 관련",
          label: "추락 및 낙하 방지조치 여부",
          is_checked: "",
        },
        {
          id: 11,
          title: "전기설비 관련",
          label: "가설시설물 변형 및 손상 여부",
          is_checked: "",
        },
        {
          id: 12,
          title: "전기설비 관련",
          label: "가설 분전함 시건 및 관리상태",
          is_checked: "",
        },
        {
          id: 13,
          title: "전기설비 관련",
          label: "용접기 단자 접지상태",
          is_checked: "",
        },
        {
          id: 14,
          title: "화학물질 관련",
          label: "위험물저장소 관리상태",
          is_checked: "",
        },
        {
          id: 15,
          title: "화학물질 관련",
          label: "물질별 MSDS 일치 및 게시여부",
          is_checked: "",
        },
        {
          id: 16,
          title: "화학물질 관련",
          label: "용접용 가스용기 전도방지조치 여부",
          is_checked: "",
        },
        {
          id: 17,
          title: "차량계하역운반기계 등",
          label: "화물 등 전도방지 여부",
          is_checked: "",
        },
        {
          id: 18,
          title: "차량계하역운반기계 등",
          label: "접촉 및 협착 방지 여부",
          is_checked: "",
        },
        {
          id: 19,
          title: "차량계하역운반기계 등",
          label: "이동동선 확보 및 유도원 배치여부",
          is_checked: "",
        },
        {
          id: 20,
          title: "차량계하역운반기계 등",
          label: "과적여부 및 운전자 시야확보 여부",
          is_checked: "",
        },
        {
          id: 21,
          title: "지휘감독",
          label: "작업구역 관리감독자 상주 여부",
          is_checked: "",
        },
      ];
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        pointInspectList: [],
        defaultInspectList: [],
        photoList: [],
        fileList: [],
        inputA_1:""
      },
    };
  },
  methods: {
    pointUpdateListCheck(indexRows, text) {
      this.form.pointInspectList[indexRows].is_checked = text;
    },
    defaultUpdateListCheck(indexRows, text) {
      this.form.defaultInspectList[indexRows].is_checked = text;
    },
    updateInspectionInfoList(list) {
      this.form.inspectionInfo = list;
    },
  },
};
</script>

<style scoped></style>
